/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geoexpand1Inputs */

const en_geoexpand1 = /** @type {(inputs: Geoexpand1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand map`)
};

const de_geoexpand1 = /** @type {(inputs: Geoexpand1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karte vergrößern`)
};

/**
* | output |
* | --- |
* | "Expand map" |
*
* @param {Geoexpand1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geoexpand1 = /** @type {((inputs?: Geoexpand1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geoexpand1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geoexpand1(inputs)
	return de_geoexpand1(inputs)
});
export { geoexpand1 as "geoExpand" }